import React from 'react';
import { Box } from '@common-fe/common-fe';

import { ChangeStatusCardModal } from '@/modules/transaction/components/Cards/components/ChangeStatusCardModal/ChangeStatusCardModal';

import { CardActivationModal } from '../Cards/components/CardActivationModals/CardActivationModal';

import { CardCarousel, CardCarouselOld } from './components/CardCarousel';
import { CardDetailsHeader } from './components/CardDetailsHeader/CardDetailsHeader';
import { CardTransactions } from './components/CardTransactionsList/CardTransactions';
import { useShipmentTrackerFeatureFlag } from './hooks';

export const CardDetails = () => {
  const isShipmentTrackerAvailable = useShipmentTrackerFeatureFlag();
  return (
    <Box data-testid="CardDetails-wrapper">
      <CardDetailsHeader />
      {isShipmentTrackerAvailable ? <CardCarousel /> : <CardCarouselOld />}

      <CardTransactions />
      <ChangeStatusCardModal />
      <CardActivationModal />
    </Box>
  );
};
